export const FETCH_FEEDBACK_OPTION_LOADING = "FETCH_FEEDBACK_OPTION_LOADING";
export const FETCH_FEEDBACK_OPTION_SUCCESS = "FETCH_FEEDBACK_OPTION_SUCCESS";
export const FETCH_FEEDBACK_OPTION_ERROR = "FETCH_FEEDBACK_OPTION_ERROR";
